import { render, staticRenderFns } from "./EnumDisplayField.vue?vue&type=template&id=67931766&scoped=true&"
import script from "./EnumDisplayField.vue?vue&type=script&lang=js&"
export * from "./EnumDisplayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67931766",
  null
  
)

export default component.exports